export function dollarsToCents (dollars) {
  return parseInt((dollars * 100).toFixed(0))
}
